import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	archivesTableLabel: {
		id: 'issue-archival-archives.archives-table.archives-table-label',
		defaultMessage: 'Archives Table',
		description: 'Label for the issue archives table',
	},
	loadingArchivesTableLabel: {
		id: 'issue-archival-archives.archives-table.loading-archives-table-label',
		defaultMessage: 'Loading archives Table',
		description: 'Loading label for the issue archives table',
	},
});
